export enum CustomFees {
  InterestGraceFee = 'InterestGracePeriodFee',
  ExitFee = 'ExitFee',
  RepaymentAmountForFactorLoanFee = 'RepaymentAmountForFactorLoan',
}
